import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function availableHoursReducer(
  state = initialState.availableHours,
  action
) {
  switch (action.type) {
    case types.LOAD_AVAILABLE_HOURS_SUCCESS:
      return action.availableHours;
    case types.RESET_AVAILABLE_HOURS_SUCCESS:
      return initialState.availableHours;
    default:
      return state;
  }
}
